module.exports = "/assets/data/87deaff7d0bc967ef5ee077434608c61-SA20.data.json";